import React from 'react';
import { ASK_COPY } from '../../utils/askScope';

// Pinned above the thread: where the questions are answered from (live vs saved HAR) and the
// limits of that source. `summary` comes from utils/askScope.scopeSummary. Presentational.
// The stripped-rows note ends in a plain hint, not a button: the Ask route cannot be scoped to a
// saved HAR from this panel (see docs/investigating-analyst-spec.md, Known limits).
export default function ScopeBar({ summary }) {
  const s = summary && typeof summary === 'object' ? summary : {};
  return (
    <div className="ask-scope">
      <span className="ask-scope-chip">{s.label || 'Live session'}</span>
      {s.usbNote ? <span className="ask-scope-chip ask-scope-chip--note" role="status">{s.usbNote}</span> : null}
      {s.strippedNote ? (
        <span className="ask-scope-chip ask-scope-chip--note" role="status">
          {s.strippedNote} {ASK_COPY.strippedHint}
        </span>
      ) : null}
    </div>
  );
}
